import { memo, useState } from 'react';
import ButtonActions from 'components/ButtonActions';
import { clientDetailsActions as TEXT } from 'locales/en/client';
import ModalWithChildren from 'components/ModalWithChildren';

const ClientDetailsActions = () => {
  const [deleteClientModal, setDeleteClientModal] = useState(false);
  const [forceDeleteClientModal, setForceDeleteClientModal] = useState(false);

  return (
    <div>
      <ButtonActions title={TEXT.buttonTitle}>
        <button
          type="button"
          className="block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer"
        >
          {TEXT.editClient}
        </button>
        <button
          type="button"
          className="block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer"
          onClick={() => setDeleteClientModal(true)}
        >
          {TEXT.deleteClient}
        </button>
        <button
          type="button"
          className="block w-full text-left bg-white py-2 px-5 text-xs text-javelin-gray-dark hover:bg-javelin-babyBlue cursor-pointer"
          onClick={() => setForceDeleteClientModal(true)}
        >
          {TEXT.forceDeleteClient}
        </button>
      </ButtonActions>

      <ModalWithChildren
        isOpen={deleteClientModal}
        header={TEXT.deleteClientModalHeader(0)}
        ctaTitle={TEXT.deleteClientModalCtaTitle}
        cta2Title={TEXT.deleteClientModalCta2Title}
        onClickCta2={() => setDeleteClientModal(false)}
      />

      <ModalWithChildren
        isOpen={forceDeleteClientModal}
        header={TEXT.forceDeleteClientModalHeader}
        ctaTitle={TEXT.deleteClientModalCtaTitle}
        cta2Title={TEXT.deleteClientModalCta2Title}
        onClickCta2={() => setForceDeleteClientModal(false)}
      />
    </div>
  );
};

export default memo(ClientDetailsActions);
